import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
export var normalize = function normalize(entityArray) {
  var schema = {
    items: {},
    list: []
  };
  var normalized = entityArray.reduce(function (normalizedObject, item) {
    var newNormalizedObject = normalizedObject;
    newNormalizedObject.list.push(item.id);
    newNormalizedObject.items[item.id] = item;
    return newNormalizedObject;
  }, schema);
  return normalized;
};